<div class="not-found">
  <div class="info">
    <h1 appTranslate>Strona nie istnieje</h1>
    <p appTranslate>
      Strona, której szukasz nie istnieje. Wróć do szablonów i spróbuj ponownie odnaleźć to czego szukałeś.
    </p>
  </div>
  <button class="button primary" routerLink="/" appTranslate>Powrót do szablonów</button>
</div>
